import {
  Box,
  Button,
  Collapse,
  GridLegacy,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import FacetSearchCard from "./facet-search-card/FacetSearchCard";
import React, { useMemo, useState } from "react";
import Facet from "models/facet-filter";
import { MaterialIcon } from "ui-widgets";
import ArrowAnimation from "datalign-module-template/components/arrow-animation";

const FacetSearchSection = ({
  title,
  type,
  facets,
}: {
  title: string;
  type: string;
  facets: Facet[];
}) => {
  const theme = useTheme();
  const easierTheme = useEasierTheme();
  const [show, setShow] = useState(false);
  const largeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const mediumScreen = useMediaQuery(theme.breakpoints.up("md"));
  const smallScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const filterRowAmount = largeScreen
    ? 4
    : mediumScreen
      ? 3
      : smallScreen
        ? 2
        : 1;
  const showList = useMemo(
    () => facets.slice(0, filterRowAmount),
    [filterRowAmount, facets],
  );
  const collapseList = useMemo(
    () => facets.slice(filterRowAmount, facets.length),
    [filterRowAmount, facets],
  );

  return (
    <Box
      sx={
        ["FAF-nt", "nrdata-orig"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? {
              mt: 2,
              p: 2,
              textAlign: "center",
              background: "hsla(0,0%,100%,.8)",
            }
          : { mt: 2, p: 2, textAlign: "center", background: "#fff" }
      }
    >
      <Typography
        variant="h2"
        color={
          ["FAF-nt", "nrdata-orig"].includes(
            process.env.REACT_APP_STYLING_THEME ?? "",
          )
            ? "#E35205"
            : easierTheme?.Colour.Secondary()
        }
        mb={3}
        fontWeight={500}
        fontSize="1.626rem"
        lineHeight={1.2}
        fontFamily="proxima,sans-serif"
        textAlign={
          ["FAF-nt", "nrdata-orig"].includes(
            process.env.REACT_APP_STYLING_THEME ?? "",
          )
            ? "left"
            : undefined
        }
        sx={{ opacity: 1 }}
      >
        {title}
      </Typography>
      <GridLegacy container spacing={3}>
        {showList.map((facet) => (
          <GridLegacy
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            key={`search-group-card-${facet.field}`}
          >
            <FacetSearchCard facetType={type} filter={facet} />
          </GridLegacy>
        ))}
        {collapseList.map((facet) => (
          <GridLegacy
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            key={`search-group-card-${facet.field}`}
            style={{
              paddingLeft: !show ? 0 : undefined,
              paddingTop: !show ? 0 : undefined,
              opacity: !show ? 0 : undefined,
            }}
          >
            <Collapse in={show}>
              <FacetSearchCard facetType={type} filter={facet} />
            </Collapse>
          </GridLegacy>
        ))}
      </GridLegacy>
      {collapseList.length > 0 && (
        <Button
          onClick={() => setShow(!show)}
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            p: 0,
            px: 1,
          }}
        >
          <Box flex={1} height="1px" bgcolor="gray" />

          <ArrowAnimation isOpen={show} />

          <Box flex={1} height="1px" bgcolor="gray" />
        </Button>
      )}
    </Box>
  );
};

export default FacetSearchSection;
